// extracted by mini-css-extract-plugin
export default {"roomsBlock":"RoomsBlock_roomsBlock__gdkyQ","imgBlock_left":"RoomsBlock_imgBlock_left__9hh2O","roomsBlock_container":"RoomsBlock_roomsBlock_container__OCXP5"};